<!-- Modal TARJETAS-->
<div class="modal fade contenedor-modal" id="modalTarjetas" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body p-0">

        <app-payment-options-mini [paraSusscripcion]="true" (fnSeleccionarTarjeta)="onSeleccionarTarjeta($event)">
        </app-payment-options-mini>

      </div>
    </div>
  </div>
</div>

<div class="pantalla clara">
  <!-- -- DESKTOP -->
  <div class="row justify-content-md-center">
    <div class="col-12 contenedor">
      <div class="row">
        <!-- BOTON SUBMENU -->
        <div class="d-lg-none w-100">
          <div class="d-flex align-items-end justify-content-end botonMenu">
            <div class="hamburger hamburger--collapse dark" (click)="submenu_alternar(true)"
              [ngClass]="{ 'is-active': submenuActive }">
              <div class="hamburger-box">
                <div class="hamburger-inner"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Izquierda -->
        <div class="col-4 d-none d-lg-block">
          <div class="list-group" id="list-tab" role="tablist">
            <a class="list-group-item list-group-item-action active" id="list-datos-personales-list" data-toggle="list"
              href="#list-datos-personales" role="tab" aria-controls="datos-personales">
              <span> <i class="fas fa-user mr-2"></i> Datos personales </span>
            </a>
            <!--
            <a
              class="list-group-item list-group-item-action"
              id="list-historial-list"
              data-toggle="list"
              href="#list-historial"
              role="tab"
              aria-controls="historial"
            >
              <span> <i class="fas fa-clock mr-2"></i> Historial </span>
            </a> -->

            <a class="list-group-item list-group-item-action" id="list-suscripcion-list" data-toggle="list"
              href="#list-suscripcion" role="tab" aria-controls="suscripcion">
              <span> <i class="fas fa-bell mr-2"></i> Suscripción </span>
            </a>

            <a class="list-group-item list-group-item-action" id="list-medios-pago-list" data-toggle="list"
              href="#list-medios-pago" role="tab" aria-controls="medios-pago" *ngIf="account?.suscription">
              <span> <i class="fas fa-credit-card mr-2"></i> Medios de pago </span>
            </a>
            <!--
            <a
              class="list-group-item list-group-item-action"
              id="list-eliminar-cuenta-list"
              data-toggle="list"
              href="#list-eliminar-cuenta"
              role="tab"
              aria-controls="eliminar-cuenta"
            >
              <span> <i class="fas fa-user-slash mr-2"></i>Eliminar cuenta </span>
            </a>
-->
          </div>
        </div>

        <!-- Derecha -->
        <div class="col-12 col-lg-8">
          <div class="tab-content" id="nav-tabContent">
            <!-- DATOS PERSONALES -->
            <div class="tab-pane fade show active" id="list-datos-personales" role="tabpanel"
              aria-labelledby="list-datos-personales-list">
              <span class="titulo">Datos personales</span>

              <!-- Datos -->
              <div class="caja" *ngIf="!cargandoDatos">
                <!-- SECCION EMAIL -->
                <div class="row">
                  <div class="col-12">
                    <h5 class="font-weight-bold">Correo electrónico</h5>
                  </div>

                  <div class="col-12">{{ datosUserForm.controls.email.value }}</div>
                </div>

                <hr class="my-4" />

                <!-- SECCION RESET CONTRASEÑA -->
                <div class="row">
                  <div class="col-12">
                    <button class="btn dropdown-toggle" data-toggle="collapse" data-target="#collapseExample"
                      aria-expanded="false" aria-controls="collapseExample">
                      CAMBIAR CONTRASEÑA
                    </button>
                  </div>

                  <!-- Formulario reset -->
                  <div class="col-12">
                    <div class="collapse" id="collapseExample">
                      <div class="card card-body">
                        <form class="text-center" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit_Password()">
                          <div class="bg-light p-3 mt-3 text-left">
                            <small> La contraseña debe contener: 8 caracteres como mínimo y al menos un número</small>
                          </div>

                          <br />

                          <!-- Password 0-->
                          <div class="form-group mb-4 text-left lg light">
                            <div class="input-group-icon">
                              <input type="password" class="form-control ojito-cerrado icon-btn"
                                placeholder="Password actual" formControlName="password0" id="password0" />

                              <!-- ICONOS OJITOS -->
                              <div class="input-group-append btn" (click)="alternarVerPassword('password0')">
                                <span class="icon ojito-slash" *ngIf="verPassword0">
                                  <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-eye-slash"
                                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                    <path
                                      d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299l.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                    <path
                                      d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709z" />
                                    <path fill-rule="evenodd" d="M13.646 14.354l-12-12 .708-.708 12 12-.708.708z" />
                                  </svg>
                                </span>

                                <span class="icon ojito-abierto" *ngIf="!verPassword0">
                                  <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-eye"
                                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                      d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z" />
                                    <path fill-rule="evenodd"
                                      d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                  </svg>
                                </span>
                              </div>
                            </div>

                            <ng-container *ngIf="
                                resetPasswordForm.get('password0').invalid && resetPasswordForm.get('password0').touched
                              ">
                              <div *ngIf="resetPasswordForm.get('password0').errors?.required" class="text-danger">
                                Debe ingresar la contraseña actual.
                              </div>
                            </ng-container>
                          </div>

                          <!-- Password 1-->
                          <div class="form-group mb-4 text-left lg light">
                            <div class="input-group-icon">
                              <input type="password" class="form-control ojito-cerrado icon-btn"
                                placeholder="Password nueva" formControlName="password1" id="password1" />

                              <!-- ICONOS OJITOS -->
                              <div class="input-group-append btn" (click)="alternarVerPassword('password1')">
                                <span class="icon ojito-slash" *ngIf="verPassword1">
                                  <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-eye-slash"
                                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                    <path
                                      d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299l.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                    <path
                                      d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709z" />
                                    <path fill-rule="evenodd" d="M13.646 14.354l-12-12 .708-.708 12 12-.708.708z" />
                                  </svg>
                                </span>

                                <span class="icon ojito-abierto" *ngIf="!verPassword1">
                                  <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-eye"
                                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                      d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z" />
                                    <path fill-rule="evenodd"
                                      d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                  </svg>
                                </span>
                              </div>
                            </div>

                            <ng-container *ngIf="
                                resetPasswordForm.get('password1').invalid && resetPasswordForm.get('password1').touched
                              ">
                              <div *ngIf="resetPasswordForm.get('password1').errors?.required" class="text-danger">
                                Debe ingresar una contraseña.
                              </div>
                              <div *ngIf="resetPasswordForm.get('password1').errors?.pattern" class="text-danger">
                                La contraseña no cumple con los criterios de seguridad.
                              </div>
                            </ng-container>
                          </div>

                          <!-- Password 2 -->
                          <div class="form-group mb-4 text-left lg light">
                            <div class="input-group-icon">
                              <input type="password" class="form-control ojito-cerrado icon-btn"
                                placeholder="Confirmar password" formControlName="password2" id="password2" />

                              <!-- ICONOS OJITOS -->
                              <div class="input-group-append btn" (click)="alternarVerPassword('password2')">
                                <span class="icon ojito-slash" *ngIf="verPassword2">
                                  <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-eye-slash"
                                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                    <path
                                      d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299l.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                    <path
                                      d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709z" />
                                    <path fill-rule="evenodd" d="M13.646 14.354l-12-12 .708-.708 12 12-.708.708z" />
                                  </svg>
                                </span>

                                <span class="icon ojito-abierto" *ngIf="!verPassword2">
                                  <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-eye"
                                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                      d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z" />
                                    <path fill-rule="evenodd"
                                      d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                  </svg>
                                </span>
                              </div>
                            </div>

                            <ng-container *ngIf="
                                resetPasswordForm.get('password2').invalid && resetPasswordForm.get('password2').touched
                              ">
                              <div *ngIf="resetPasswordForm.get('password2').errors?.required" class="text-danger">
                                Debe ingresar una contraseña.
                              </div>
                              <div *ngIf="resetPasswordForm.get('password2').errors?.noiguales" class="text-danger">
                                Las contraseñas deben ser iguales.
                              </div>
                            </ng-container>
                          </div>

                          <!-- ENVIAR RESET -->
                          <div class="form-group mt-3">
                            <button class="btn btn-block btn-lg my-4" type="submit"
                              [ngClass]="{ disabled: !resetPasswordForm.valid }">
                              <span *ngIf="cargando" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                              <span *ngIf="!cargando">RESETEAR PASSWORD</span>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <hr class="my-4" />

                <!-- SECCION DATOS PERSONALES -->
                <div class="row">
                  <div class="col-12" *ngIf="!cargandoDatos">
                    <form [formGroup]="datosUserForm" (ngSubmit)="onSubmit_DatosPersonales()">
                      <div class="row">
                        <!-- Nombre -->
                        <div class="col-12 form-group mb-4 text-left">
                          <label class="font-weight-bold"> Nombre</label>
                          <input type="text" class="form-control input" placeholder="Nombre"
                            formControlName="firstName" />

                          <ng-container
                            *ngIf="datosUserForm.get('firstName').invalid && datosUserForm.get('firstName').touched">
                            <div *ngIf="datosUserForm.get('firstName').errors?.required" class="text-danger">
                              Debe ingresar un nombre.
                            </div>
                          </ng-container>
                        </div>

                        <!-- Apellido -->
                        <div class="col-12 form-group mb-4 text-left">
                          <label class="font-weight-bold"> Apellido</label>
                          <input type="text" class="form-control" placeholder="Apellido" formControlName="lastName" />

                          <ng-container
                            *ngIf="datosUserForm.get('lastName').invalid && datosUserForm.get('lastName').touched">
                            <div *ngIf="datosUserForm.get('lastName').errors?.required" class="text-danger">
                              Debe ingresar un apellido.
                            </div>
                          </ng-container>
                        </div>

                        <!-- Documento -->
                        <div class="col-12 form-group mb-4 text-left">
                          <label class="font-weight-bold"> Documento</label>
                          <input type="text" class="form-control" placeholder="Documento"
                            formControlName="documentId" />

                          <ng-container
                            *ngIf="datosUserForm.get('documentId').invalid && datosUserForm.get('documentId').touched">
                            <div *ngIf="datosUserForm.get('documentId').errors?.required" class="text-danger">
                              Debe ingresar un número de documento.
                            </div>
                            <div *ngIf="datosUserForm.get('documentId').errors?.documentId" class="text-danger">
                              Debe ingresar un documento válido.
                            </div>
                          </ng-container>
                        </div>

                        <!-- Phone -->
                        <div class="col-12 form-group mb-4 text-left">
                          <label class="font-weight-bold"> Teléfono</label>
                          <input type="text" class="form-control" placeholder="Teléfono"
                            formControlName="phoneNumber" />

                          <ng-container
                            *ngIf="datosUserForm.get('phoneNumber').invalid && datosUserForm.get('phoneNumber').touched">
                            <div *ngIf="datosUserForm.get('phoneNumber').errors?.required" class="text-danger">
                              Debe ingresar un número de teléfono/celular.
                            </div>
                            <div *ngIf="datosUserForm.get('phoneNumber').errors?.pattern" class="text-danger">
                              Debe ingresar un número de teléfono/celular válido.
                            </div>
                          </ng-container>
                        </div>

                        <!-- Dirección -->
                        <div class="col-12 form-group mb-4 text-left">
                          <label class="font-weight-bold"> Dirección completa</label>
                          <input type="text" class="form-control" placeholder="Dirección completa"
                            formControlName="address" />

                          <ng-container
                            *ngIf="datosUserForm.get('address').invalid && datosUserForm.get('address').touched">
                            <div *ngIf="datosUserForm.get('address').errors?.required" class="text-danger">
                              Debe ingresar una dirección.
                            </div>
                          </ng-container>
                        </div>

                        <!-- Ciudad -->
                        <div class="col-12 form-group mb-4 text-left">
                          <label class="font-weight-bold"> Ciudad</label>
                          <input type="text" class="form-control" placeholder="Ciudad" formControlName="city" />

                          <ng-container *ngIf="datosUserForm.get('city').invalid && datosUserForm.get('city').touched">
                            <div *ngIf="datosUserForm.get('city').errors?.required" class="text-danger">
                              Debe ingresar una ciudad.
                            </div>
                          </ng-container>
                        </div>

                        <!-- Zip Code -->
                        <div class="col-12 form-group mb-4 text-left">
                          <label class="font-weight-bold"> Codigo Postal</label>
                          <input type="number" class="form-control" placeholder="Codigo Postal"
                            formControlName="zipcode" />

                          <ng-container
                            *ngIf="datosUserForm.get('zipcode').invalid && datosUserForm.get('zipcode').touched">
                            <div *ngIf="datosUserForm.get('zipcode').errors?.required" class="text-danger">
                              Debe ingresar una dirección.
                            </div>
                          </ng-container>
                        </div>

                        <!-- Departamento -->
                        <div class="col-12 form-group mb-4 text-left">
                          <label class="font-weight-bold"> Departamento</label>
                          <input type="text" class="form-control" placeholder="Departamento" formControlName="state" />

                          <ng-container
                            *ngIf="datosUserForm.get('state').invalid && datosUserForm.get('state').touched">
                            <div *ngIf="datosUserForm.get('state').errors?.required" class="text-danger">
                              Debe ingresar un departamento.
                            </div>
                          </ng-container>
                        </div>

                        <!-- País -->
                        <div class="col-12 form-group mb-4 text-left">
                          <label class="font-weight-bold"> País</label>
                          <input type="text" class="form-control" placeholder="País" formControlName="country" />

                          <ng-container
                            *ngIf="datosUserForm.get('country').invalid && datosUserForm.get('country').touched">
                            <div *ngIf="datosUserForm.get('country').errors?.required" class="text-danger">
                              Debe ingresar un país.
                            </div>
                          </ng-container>
                        </div>

                        <!-- Biografía -->
                        <div class="col-12 form-group mb-4 text-left">
                          <label class="font-weight-bold"> Biografía</label>
                          <textarea type="text" class="form-control py-3" placeholder="Biografía" formControlName="bio"
                            rows="4" [maxlength]="maxLengthBio"></textarea>

                          <span class="font-weight-bold"
                            [ngClass]="{'text-danger': datosUserForm.get('bio').value.length > maxLengthBio - 10}">
                            {{datosUserForm.get('bio').value.length}}
                          </span>

                          / {{maxLengthBio}}

                        </div>

                        <br />

                        <div class="col-12 form-group">
                          <button class="btn btn-block btn-lg my-4" type="submit"
                            [ngClass]="{ disabled: !datosUserForm.valid }">
                            <span *ngIf="cargando" class="spinner-border spinner-border-sm" role="status"
                              aria-hidden="true"></span>
                            <span *ngIf="!cargando">Guardar</span>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div class="col-12" *ngIf="cargandoDatos">
                    <div class="w-100 d-flex justify-content-center p-3">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Loading -->
              <div class="caja" *ngIf="cargandoDatos">
                <div class="w-100 d-flex justify-content-center p-3">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </div>
              </div>
            </div>

            <!-- HISTORIAL -->
            <!-- <div class="tab-pane fade" id="list-historial" role="tabpanel" aria-labelledby="list-historial-list">
              <span class="titulo">Historial</span>
              <div class="caja">historial</div>
            </div> -->

            <!-- SUSCRIPCION -->
            <div class="tab-pane fade" id="list-suscripcion" role="tabpanel" aria-labelledby="list-suscripcion-list">
              <span class="titulo">Suscripción</span>

              <!-- SI ESTÁ SUSCRITO -->
              <div class="caja" *ngIf="account?.suscription && account?.suscription.status == 1 && !cargandoDatos">
                <!-- Suscripción -->
                <div class="row mb-4">
                  <div class="col-12">
                    <h5 class="font-weight-bold">Suscripción</h5>
                    <button type="button" class="btn btn-outline-dark border-darken-2 disabled">
                      <strong>{{ account.suscription.subscriptionPlan }}</strong>
                    </button>
                    <span class="text-muted ml-2">Su Suscripción se encuentra activa.</span>
                  </div>
                </div>

                <!-- Datos suscripcion -->
                <div *ngIf="account?.suscription?.status !=3">
                  <!-- Inicio y Fin -->
                  <div class="row mb-4">
                    <div class="col-12">
                      <h5 class="font-weight-bold">Inicio - Fin</h5>
                    </div>

                    <div class="col-12">
                      {{ account.suscription.activePeriodStart | date: 'dd/MM/yyyy' }} -
                      {{ account.suscription.activePeriodEnd | date: 'dd/MM/yyyy' }}
                    </div>
                  </div>
                </div>

                <!-- DESUSCRIBIRSE -->
                <h5 class="font-weight-bold">Cancelar suscripción</h5>
                <p class="text-muted">
                  Seguir siendo parte de +Cinemateca nos permite gestionar más y mejores películas para todos.
                  Agradecemos tu esfuerzo.
                </p>

                <!-- Boton para cancelar suscripcion -->
                <div class="botonCancelar" *ngIf="mostrarBotonCancelar">
                  <div class="row mb-4">
                    <div class="col-12">
                      <button class="btn btn-danger bg-danger text-white" type="button"
                        (click)="onCancelarSuscripcion()">
                        Cancelar Suscripción
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Error en el pago -->
                <div *ngIf="account?.suscription?.status == 3">
                  <div class="bg-light p-4 text-center " role="alert">
                    <h5 class="font-weight-bold mb-3">Error en el pago de suscripción</h5>


                    Ha ocurrido un error en el pago mensual de la suscripción. <br>
                    Cambie la tarjeta en la sección <strong>Medios de pago</strong> para reintentar el pago de la
                    suscripción.
                    <br> <br>
                    También puede contactar con Cinemateca <br> por <strong>teléfono:</strong>
                    <a href="tel:+59829147569"> (+598) 2914 7569 </a> o bien <a href="contact">enviar un mensaje</a>.

                    <br><br>

                  </div>
                </div>

              </div>

              <!-- SI NO ESTA SUSCRITO -->
              <div class="caja" *ngIf="!account?.suscription || account.suscription?.status != 1 && !cargandoDatos">
                <div class="row">
                  <div class="col-12">
                    <div class="text-center pt-5 pb-2" style="font-size: 8rem; opacity: 0.4">
                      <i class="far fa-frown"></i>
                    </div>
                  </div>

                  <div class="col-12 text-center">
                    <h3><strong>No está suscrito a +Cinemateca.</strong></h3>
                  </div>

                  <div class="col-12 text-center">
                    <p style="" class="text-muted">
                      <strong>Suscríbase ahora para disfrutar de toda nustra cartelera de movies, promociones y
                        más.</strong>
                    </p>
                  </div>

                  <div class="col-12 text-center py-5 mb-5">
                    <button class="btn pink btn-block text-white btn-lg" [routerLink]="['/suscripcion']">
                      SUSCRIBIRSE AHORA
                    </button>
                  </div>
                </div>
              </div>

              <!-- SI ES MIEMBRO CINEMTATECA -->
              <div class="caja" *ngIf="account?.isCinematecaMember && !cargandoDatos">
                <div class="row mb-2">
                  <div class="col-12">
                    <h5 class="font-weight-bold">Miembro cinemateca</h5>

                    <span class="text-muted"> Tiene los beneficios de socio de Cinemateca activos. </span>
                  </div>
                </div>

                <!-- DESUSCRIBIRSE -->
                <!-- <h5 class="font-weight-bold">Desuscripción</h5>
                <p class="text-muted">
                  Al desuscribirte, ya no podrás disfrutar de nuestra cartera VIP de forma rápida.
                </p>

                <br /><br />

                <button class="btn btn-danger bg-danger font-weight-bold" onClick="alert('impactar en el backend')">
                  DESUSCRIBIRME
                </button> -->
              </div>

              <!-- LOADING -->
              <div class="caja" *ngIf="cargandoDatos">
                <div class="w-100 d-flex justify-content-center p-3">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </div>
              </div>
            </div>

            <!-- MEDIOS DE PAGO -->
            <div class="tab-pane fade" id="list-medios-pago" role="tabpanel" aria-labelledby="list-medios-pago-list"
              *ngIf="account?.suscription">
              <span class="titulo">Medios de pago</span>

              <!-- Tarjeta seleccionada -->
              <div class="caja">

                <!-- Suscripción -->
                <div class="row mb-4">
                  <div class="col-12">
                    <h5 class="font-weight-bold">Para suscripción</h5>

                    <!-- Loading -->
                    <div class="w-100 d-flex justify-content-center p-3" *ngIf="cargandoTarjetas">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </div>

                    <!-- Tarjeta  -->
                    <div *ngIf="!cargandoTarjetas">
                      <p class="text-muted">Medio de pago seleccionado para la suscripción mensual.</p>

                      <app-payment-card [tarjeta]="tarjetaSeleccionada" [cuenta]="account"></app-payment-card>

                      <button class="btn mt-4 " (click)="abrirModalTarjetas()">
                        CAMBIAR MEDIO
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!-- ELIMINAR CUENTA -->
            <div class="tab-pane fade" id="list-eliminar-cuenta" role="tabpanel"
              aria-labelledby="list-eliminar-cuenta-list">
              <span class="titulo">ELIMINAR CUENTA</span>
              <div class="caja">
                <h4>¿Quiere eliminar la cuenta de +Cinemateca?</h4>
                <br />
                <br />

                <h5 class="font-weight-bold">¿Perderé toda la información de mi cuenta?</h5>
                <p class="text-muted">Sí, una vez elimines tu usuario de +Cinemateca se perderá todo tu historial.</p>

                <br />

                <h5 class="font-weight-bold">¿Qué ocurrirá con mi suscripción?</h5>
                <p class="text-muted">
                  Si tienes una suscripción activa también se eliminará. No podrás hacer uso de los días que te quedan
                  ni de los tickets restantes.
                </p>

                <br />

                <button class="btn btn-danger bg-danger"><i class="fas fa-trash"></i> ELIMINAR CUENTA</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- -- SUB MENU MOBILE -->
  <div class="sub-menu d-lg-none" [ngClass]="{ active: submenuActive }">
    <div class="fondo" (click)="submenu_alternar(false)"></div>

    <div class="contenedor">
      <!-- Icono menu -->
      <div class="d-flex align-items-end justify-content-end botonMenu mt-4 mb-5">
        <div class="hamburger hamburger--collapse white" (click)="submenu_alternar(false)"
          [ngClass]="{ 'is-active': submenuActive }">
          <div class="hamburger-box">
            <div class="hamburger-inner"></div>
          </div>
        </div>
      </div>

      <!-- Lista items -->
      <div class="list-group" id="list-tab" role="tablist" (click)="submenu_alternar(false)">
        <a class="list-group-item list-group-item-action active" id="list-datos-personales-list" data-toggle="list"
          href="#list-datos-personales" role="tab" aria-controls="datos-personales">
          <span> Datos personales <i class="fas fa-user ml-2"></i> </span>
        </a>

        <!-- <a
          class="list-group-item list-group-item-action"
          id="list-historial-list"
          data-toggle="list"
          href="#list-historial"
          role="tab"
          aria-controls="historial"
        >
          <span> Historial <i class="fas fa-clock ml-2"></i> </span>
        </a> -->

        <a class="list-group-item list-group-item-action" id="list-medios-pago-list" data-toggle="list"
          href="#list-medios-pago" role="tab" aria-controls="medios-pago">
          <span>Medios de pago <i class="fas fa-credit-card ml-2"></i></span>
        </a>

        <a class="list-group-item list-group-item-action" id="list-eliminar-cuenta-list" data-toggle="list"
          href="#list-eliminar-cuenta" role="tab" aria-controls="eliminar-cuenta">
          <span>Eliminar cuenta <i class="fas fa-user-slash ml-2"></i></span>
        </a>
      </div>
    </div>
  </div>
</div>